import { renderPrintDocument } from "../../core/renderPrintDocument";
import { escapeHtml } from "../../shared/escapeHtml";
import { officialDocumentStyles } from "../../shared/officialDocumentStyles";
import { createObqRobPrintViewModelV2 } from "./createObqRobPrintViewModelV2";

const obqRobStylesV2 = `
  ${officialDocumentStyles}

  .obq-rob-table td:nth-child(2),
  .obq-rob-table td:nth-child(4),
  .obq-rob-table td:nth-child(5) {
    text-align: center;
  }
`;

const formatValue = (value) => (value === undefined || value === null || value === "" ? "\u2014" : String(value));

const renderObqRobBody = (model, t) => `
  <main class="official-document">
    <header class="official-header">
      <div class="official-logo-wrap">
        ${
          model.companyLogo
            ? `<img src="${escapeHtml(model.companyLogo)}" alt="Company logo" class="official-logo" />`
            : ""
        }
      </div>
      <div class="official-header-main">
        <h1 class="official-vessel-name">${escapeHtml(model.vesselName)}</h1>
        <h2 class="official-title">${escapeHtml(model.title)}</h2>
      </div>
    </header>

    <hr class="official-rule" />

    <table class="official-meta" aria-label="Document metadata">
      <tbody>
        <tr>
          <td class="official-meta-label">Voyage No.:</td>
          <td class="official-meta-value">${escapeHtml(model.voyageNumber)}</td>
          <td class="official-meta-label">${escapeHtml(t("voyageInfo.date"))}:</td>
          <td class="official-meta-value">${escapeHtml(model.tripDate)}</td>
        </tr>
        <tr>
          <td class="official-meta-label">${escapeHtml(t("voyageInfo.port"))}:</td>
          <td class="official-meta-value">${escapeHtml(model.portName)}</td>
          <td class="official-meta-label">${escapeHtml(t("voyageInfo.jetty"))}:</td>
          <td class="official-meta-value">${escapeHtml(model.jettyName)}</td>
        </tr>
        <tr>
          <td class="official-meta-label">${escapeHtml(t("voyageInfo.condition"))}:</td>
          <td class="official-meta-value">${escapeHtml(model.condition)}</td>
          <td class="official-meta-label">${escapeHtml(t("voyageInfo.draft"))}:</td>
          <td class="official-meta-value">${escapeHtml(
            `FWD: ${formatValue(model.draft?.fwd)} | AFT: ${formatValue(model.draft?.aft)} | Trim: ${formatValue(model.draft?.trim)}`
          )}</td>
        </tr>
      </tbody>
    </table>

    <hr class="official-meta-separator" />

    <section class="official-section">
      <table class="official-table obq-rob-table">
        <thead>
          <tr>
            <th>${escapeHtml(t("table.tank"))}</th>
            <th>${escapeHtml(t("table.dip"))}</th>
            <th>${escapeHtml(t("table.cargo"))}</th>
            <th>${escapeHtml(t("table.dens15c"))}</th>
            <th>${escapeHtml(t("table.volumem3"))}</th>
            <th>${escapeHtml(t("table.remarks"))}</th>
          </tr>
        </thead>
        <tbody>
          ${model.cargoData
            .map(
              (row) => `
                <tr>
                  <td>${escapeHtml(formatValue(row.tank))}</td>
                  <td>${escapeHtml(formatValue(row.dip))}</td>
                  <td>${escapeHtml(formatValue(row.cargo))}</td>
                  <td>${escapeHtml(formatValue(row.dens))}</td>
                  <td>${escapeHtml(formatValue(row.volume))}</td>
                  <td>${escapeHtml(formatValue(row.remarks))}</td>
                </tr>
              `
            )
            .join("")}
          <tr>
            <td colspan="4"></td>
            <td><strong>${escapeHtml(formatValue(model.totalVolume))}</strong></td>
            <td>${escapeHtml(t("table.totalVolume"))}</td>
          </tr>
          <tr>
            <td colspan="4"></td>
            <td><strong>${escapeHtml(formatValue(model.totalMt))}</strong></td>
            <td>${escapeHtml(t("table.totalMt"))}</td>
          </tr>
        </tbody>
      </table>

      <div class="official-check-row">
        <span class="official-check-item">
          <span class="official-checkbox">${model.isLiquid ? "X" : ""}</span>
          ${escapeHtml(t("table.robLiquid"))}
        </span>
        <span class="official-check-item">
          <span class="official-checkbox">${model.isResidues ? "X" : ""}</span>
          ${escapeHtml(t("table.robResidue"))}
        </span>
      </div>
    </section>
  </main>
`;

export const renderObqRobV2 = (input) => {
  const model = createObqRobPrintViewModelV2(input);

  return renderPrintDocument({
    title: model.title,
    templateId: "obq-rob",
    viewModel: model,
    styles: obqRobStylesV2,
    body: renderObqRobBody(model, input.t),
  });
};
